import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type SearchTextState = string

export const searchTextSlice = createSlice({
  name: 'searchText',
  initialState: '' as SearchTextState,
  reducers: {
    setSearchText: (state: SearchTextState, action: PayloadAction<string>) => {
      return action.payload
    },
  },
})

export const { setSearchText } = searchTextSlice.actions
